// Utilitaire pour vérifier l'accès GuardIA
export class GuardiaAccessChecker {
  static featureLabels = {
    listen: 'GuardIA Listen',
    chat: 'GuardIA Chat',
    vision: 'GuardIA Vision',
    audio: 'GuardIA Audio',
    resume: 'GuardIA Resume',
    check: 'GuardIA Check',
    write: 'GuardIA Write',
    synthese: 'GuardIA Synthèse',
  };

  static normalizeSettings(settings) {
    const guardiaOn = typeof settings?.guardiaOn === 'boolean' ? settings.guardiaOn : false;
    const sourceFeatures = settings?.features && typeof settings.features === 'object' ? settings.features : {};
    const featureKeys = Object.keys(GuardiaAccessChecker.featureLabels);
    const features = featureKeys.reduce((acc, key) => {
      acc[key] = typeof sourceFeatures[key] === 'boolean' ? sourceFeatures[key] : guardiaOn;
      return acc;
    }, {});

    return {
      ...settings,
      guardiaOn,
      features
    };
  }

  static async fetchAccessContext() {
    const token = sessionStorage.getItem('authToken');
    const authOptions = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    const settingsResponse = await fetch('/api/guardiasettings', authOptions);
    if (!settingsResponse.ok) {
      return {
        hasAccess: false,
        reason: 'Erreur lors de la vérification des paramètres GuardIA',
      };
    }

    const rawSettings = await settingsResponse.json();
    const settings = GuardiaAccessChecker.normalizeSettings(rawSettings);

    if (!settings.guardiaOn) {
      return {
        hasAccess: false,
        reason: 'L\'accès à l\'assistant GuardIA n\'est pas activé avec votre licence BlueNote.',
        settings
      };
    }

    const accessResponse = await fetch('/api/guardiasettings/access', authOptions);
    if (!accessResponse.ok) {
      return {
        hasAccess: false,
        reason: 'L\'accès à l\'assistant GuardIA n\'est pas activé avec votre licence BlueNote.',
        settings
      };
    }

    const accessData = await accessResponse.json();
    if (!accessData.hasAccess) {
      return {
        hasAccess: false,
        reason: 'L\'accès à l\'assistant GuardIA n\'est pas activé avec votre licence BlueNote.',
        settings
      };
    }

    return {
      hasAccess: true,
      reason: 'Accès autorisé',
      settings
    };
  }

  static async checkAccess() {
    try {
      const result = await GuardiaAccessChecker.fetchAccessContext();
      return { hasAccess: result.hasAccess, reason: result.reason };
    } catch (error) {
      console.error('Erreur lors de la vérification de l\'accès GuardIA:', error);
      return { hasAccess: false, reason: 'L\'accès à l\'assistant GuardIA n\'est pas activé avec votre licence BlueNote.' };
    }
  }

  static async checkFeatureAccess(featureKey) {
    try {
      const result = await GuardiaAccessChecker.fetchAccessContext();
      if (!result.hasAccess) {
        return { hasAccess: false, reason: result.reason };
      }

      const { settings } = result;
      const isEnabled = Boolean(settings?.features?.[featureKey]);
      if (!isEnabled) {
        const label = GuardiaAccessChecker.featureLabels[featureKey] || 'cette fonctionnalité';
        return {
          hasAccess: false,
          reason: `La fonctionnalité ${label} est désactivée par l'administrateur.`
        };
      }

      return { hasAccess: true, reason: 'Accès autorisé' };
    } catch (error) {
      console.error('Erreur lors de la vérification de la fonctionnalité GuardIA:', error);
      return { hasAccess: false, reason: 'L\'accès à l\'assistant GuardIA n\'est pas activé avec votre licence BlueNote.' };
    }
  }
}
